import React from 'react';
import styles from './InputTextAreaCount.module.scss';

interface IInputTextAreaCountProps {
  maxLength: number;
  value: string;
}

export default function InputTextAreaCount({
  maxLength,
  value = '',
}: IInputTextAreaCountProps) {
  const getMessage = () => {
    const charactersLeft = maxLength - value.length;
    if (charactersLeft === 1) {
      return `${charactersLeft} character left`;
    }
    if (charactersLeft === 0) {
      return 'no characters left';
    }
    return `${charactersLeft} characters left`;
  };
  return (
    <span
      className={styles['a-input-text-area-count']}
    >
      {getMessage()}
    </span>
  );
}
